import React, {useEffect, useState} from 'react';
import {useDropzone} from 'react-dropzone';

export default function UiFileUploader(props) {
  const [files, setFiles] = useState([]);
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/*': [],
      'video/mp4': ['.mp4', '.MP4'],
    },
    onDrop: acceptedFiles => {
      setFiles(acceptedFiles.map(file => Object.assign(file, {
        preview: URL.createObjectURL(file)
      })));
    }
  });

  const filesObj = files.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const thumbs = files.map(file => (
    <div key={file.name} className='sba-upload-file-preview'>
        {file.type == "video/mp4" ?
          <video width="400" controls >
            <source src={file.preview} type="video/mp4" />
          </video> : 
          <img
            className='sba-img-file-preview'
            src={file.preview}
            onLoad={() => { URL.revokeObjectURL(file.preview) }}
          />
        }
    </div>
  ));

  useEffect(() => {
    return () => files.forEach(file => URL.revokeObjectURL(file.preview));
  }, []);

  return (
    <section className="sba-uploader-container">      
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <p>{props.uplodaContent ? props.uplodaContent :"Drag 'n' drop some files here, or click to select files"}</p>
      </div>

      {props.preview ?
        <aside>
          {thumbs}
        </aside> :
        <aside>
          <ul className='sba-uploader-container__list'>{filesObj}</ul>
        </aside>
      }

    </section>
  );
}
